import React from 'react';
import { Text } from '@hub/text';
import { Link } from '@hub/link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const ColorCardWithoutImage = _ref => {
  let {
    banner,
    termsAndConditionsLink
  } = _ref;
  const {
    title,
    bodyCopy
  } = banner;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      isBodyText: true,
      as: "h1",
      fontSize: ['font-h4', 'font-h3', 'font-h2', 'font-h1'],
      tone: "strong",
      sx: {
        marginBottom: 'spacing-sm'
      },
      "data-id": "color-cards-without-image_index_ColorCardWithoutImage_Text",
      children: title
    }), /*#__PURE__*/_jsxs(Text, {
      isBodyText: true,
      color: "licorice",
      "data-id": "color-cards-without-image_index_ColorCardWithoutImage_Text_1",
      children: [bodyCopy && "".concat(bodyCopy, " "), termsAndConditionsLink && /*#__PURE__*/_jsx(Link, {
        hasUnderline: true,
        href: termsAndConditionsLink,
        "data-id": "color-cards-without-image_index_ColorCardWithoutImage_Link",
        children: "See T&Cs for details."
      })]
    })]
  });
};